/*
 * Copyright (c) 2023 Powerledger Pty Ltd. All Rights Reserved.
 */

import { RegionSelectionStepView } from "./region-selection-step-view";
import { useRegionSelectStep } from "./use-region-selection-step";

export const RegionSelectionStep = () => {
  const logic = useRegionSelectStep();
  return <RegionSelectionStepView {...logic} />;
};
